// extracted by mini-css-extract-plugin
module.exports = {"photoContainer":"property_photo_photoContainer__3BjXF","picture":"property_photo_picture__2B3SE"};